import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const l = e((s, r) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: r,
    ...s,
    image: (t) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...t,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "m9.414 8 5.293-5.293-1.414-1.414L8 6.586 2.707 1.293 1.293 2.707 6.586 8l-5.293 5.293 1.414 1.414L8 9.414l5.293 5.293 1.414-1.414z"
          }
        )
      }
    )
  }
));
l.displayName = "CrossIcon";
export {
  l as CrossIcon,
  l as default
};
//# sourceMappingURL=index.js.map
